/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Plan_CurrentInputs */

const cs_billing_plan_current = /** @type {(inputs: Billing_Plan_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuální tarif`)
};

const en_billing_plan_current = /** @type {(inputs: Billing_Plan_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current plan`)
};

/**
* | output |
* | --- |
* | "Current plan" |
*
* @param {Billing_Plan_CurrentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_current = /** @type {((inputs?: Billing_Plan_CurrentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_CurrentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_current(inputs)
	return cs_billing_plan_current(inputs)
});